import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormViewComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { LoginFormTypes } from "models/formTypes";
import { InputProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { PasswordInput, useWintForm, VerticalFormField, WintForm } from "components/common/wintForms";
//#endregion

const ResetPasswordForm: ForwardRefRenderFunction<FormHandles, BaseFormViewComponentProps> = (props, ref) => {
  const { wintFormProps, connect } = useWintForm<LoginFormTypes.ResetPassword>({
    formRef: ref,
    ...props,
    validateOnBlur: true,
  });

  return (
    <WintForm {...wintFormProps}>
      <VerticalFormField<InputProps>
        Component={PasswordInput}
        {...connect("password")}
        label={TranslationKeys.Login.NewPassword}
        icon={IconDefinitionConstants.WLock}
      />
      <VerticalFormField<InputProps>
        Component={PasswordInput}
        {...connect("confirmPassword")}
        label={TranslationKeys.Login.ConfirmPassword}
        icon={IconDefinitionConstants.WLock}
      />
    </WintForm>
  );
};

export default forwardRef(ResetPasswordForm);
